const SidebarSectionMessage = <template>
  <div class="sidebar-section-message-wrapper sidebar-row">
    <div class="sidebar-section-message">
      {{yield}}
    </div>
  </div>
</template>;

export default SidebarSectionMessage;
